import whenDomReady from 'when-dom-ready';

import '../../styles/pages/404.scss';

whenDomReady(() => {
  console.log('Init 404');
});